import React, { useState } from 'react';

export default function TermsConditionsSch({ onAccept }) {
  const [isChecked, setIsChecked] = useState(false); // กำหนดสถานะของ checkbox
  const [isLoading, setIsLoading] = useState(false); // สถานะการโหลด

  // ฟังก์ชันสำหรับการตรวจสอบ checkbox
  const handleCheck = () => {
    setIsChecked(!isChecked);
  };

  // ฟังก์ชันสำหรับการคลิกปุ่ม Continue
  const handleContinue = () => {
    if (isChecked) {
      setIsLoading(true); // ตั้งค่าการโหลดเมื่อคลิก
      // จำลองการทำงานต่อไป เช่นการส่งข้อมูล
      setTimeout(() => {
        setIsLoading(false);
        onAccept(); // เมื่อโหลดเสร็จเรียกฟังก์ชัน onAccept
      }, 2000); // จำลองเวลาโหลด 2 วินาที
    }
  };

  return (
    <div className="fixed inset-0 bg-white flex items-center justify-center z-50">
      {/* โลโก้ Charles Schwab อยู่มุมซ้ายบน */}
      <img
        src="/photo/charlesschwab.jpg"
        alt="Charles Schwab"
        className="absolute top-4 left-4 w-16"
      />

      <div className="max-w-3xl mx-auto p-6 bg-white rounded-lg relative overflow-y-auto max-h-[80vh]">
        <h1 className="text-2xl font-bold text-center text-purple-800 mb-6">Trader API End User Terms and Conditions</h1>

        <h2 className="text-xl font-semibold text-purple-700 mb-4">Instruction to Grant Access and Agreement to Allow Quantum Flo Auto Algo to Access Your Account and Account Information</h2>

        <p className="text-gray-700 mb-4">
          Please read the following and provide your agreement to these Trader API End User Terms and Conditions (“Terms and Conditions”). By clicking “Continue,” you are instructing Schwab to grant access to your account and Account Information (as defined below) to a Third-Party Application (as defined below) utilizing Schwab’s Trader API Program (the “Program”). Schwab may, at any time without prior notice, amend these Terms and Conditions. The current Terms and Conditions are available for your reference on this login page. Your continued use of a Third-Party Application constitutes your acceptance of the changes.
        </p>

        <h3 className="text-lg font-semibold text-gray-800 mb-2">Your Instruction to Schwab</h3>
        <p className="text-gray-700 mb-4">
          You are instructing Charles Schwab & Co., Inc. (“Schwab,” “we,” or “us”) to allow one or more third-party applications, the provider of those applications, and their personnel and agents (each a “Third-Party Application”) that you designate to access your Schwab account and your Account Information. By instructing us to do this, you agree to these Terms and Conditions, and agree to accept the responsibilities and risks summarized below. We may change, suspend, or cancel your instruction at any time and for any reason.
        </p>

        <h3 className="text-lg font-semibold text-gray-800 mb-2">Your Agreement to Grant Access</h3>
        <p className="text-gray-700 mb-4">
          By instructing us to grant access to your Schwab account, you agree that the Third-Party Application will be able to access your account to place, edit, or cancel orders. You agree that you are solely responsible (financially and otherwise) for all orders and trades placed in your account through or using the Third-Party Application. You further understand and agree that all interactions from a Third-Party Application will be monitored and subject to restrictions based on the nature of the activity at our sole discretion. You understand and agree that Schwab has no responsibility for, and makes no representations regarding, the availability, performance, quality, reliability, or fitness of any Third-Party Application, and that Schwab’s ability to act on account instructions, including order placement, is dependent on the Third-Party Application’s availability and fitness for use with the Program. As such, Schwab will not be liable for the unavailability, delay, or failure of the Third-Party Application to process account instructions. Your use of the Third-Party Application relating to your Schwab account is subject to the Schwab Client Agreement, Privacy Notice, and other applicable agreements governing your Schwab account.
        </p>

        <h3 className="text-lg font-semibold text-gray-800 mb-2">The Third-Party Application is an Authorized Person</h3>
        <p className="text-gray-700 mb-4">
          You understand and agree that by instructing us to grant access to your Schwab account to a Third-Party Application, you are authorizing any activity (including trading activity) that the Third-Party Application undertakes, even if you did not authorize or consent to that activity. You understand and agree that granting access to your Schwab account could potentially expose you to increased privacy and security risks, including fraud and unauthorized transactions, and that Schwab will not be responsible for such activity.
        </p>

        <h3 className="text-lg font-semibold text-gray-800 mb-2">The Account Information You Will Be Sharing</h3>
        <p className="text-gray-700 mb-4">
          For each Schwab account that you instruct us to link to a Third-Party Application, you are granting the Third-Party Application access to your Account Information, which includes, but is not limited to, your holdings, balances, transaction history (such as buys, sells, journals, dividends, commissions and fees, payments, interest, ATM activity, adjustments, deposits, withdrawals, transfers, checks, taxes, and corporate actions), account descriptors, and other account details (collectively, the “Account Information”).
        </p>

        <h3 className="text-lg font-semibold text-gray-800 mb-2">You Must Safeguard Your Login Credentials</h3>
        <p className="text-gray-700 mb-4">
          You are responsible for maintaining the confidentiality and security of your Login Credentials and for immediately notifying Schwab if you believe the confidentiality or security of the Login Credentials has been compromised. You are responsible for all activities that occur using your Login Credentials, regardless of whether the activities are undertaken by you or someone else. You may not share your Login Credentials with anyone, including with any Third-Party Application.
        </p>

        <h3 className="text-lg font-semibold text-gray-800 mb-2">How the Schwab Security Guarantee Applies</h3>
        <p className="text-gray-700 mb-4">
          The Schwab Security Guarantee covers losses in your Schwab accounts due to unauthorized activity. You understand that the Schwab Security Guarantee will not apply to losses caused by the use, disclosure, or exposure of your Account Information by the Third-Party Application or other third party with whom a Third-Party Application shares your Account Information.
        </p>

        {/* Checkbox for agreeing to terms */}
        <div className="flex items-center mb-6">
          <input
            type="checkbox"
            id="acceptTerms"
            checked={isChecked}
            onChange={handleCheck}
            className="mr-2"
          />
          <label htmlFor="acceptTerms" className="text-gray-700 text-base">
            I agree to the terms and conditions
          </label>
        </div>

        {/* Continue Button */}
        <button
          onClick={onAccept}
          className="block mx-auto bg-green-600 hover:bg-green-700 text-white py-2 px-6 rounded"
        >
          Continue
        </button>
      </div>
    </div>
  );
}
